import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useRoute } from "vue-router";
import WebComponent from "./webComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'exampleComponent',
  setup(__props) {

const route = useRoute(); // 获取路由对象

// 使用 computed 来计算所有需要的值
const leftSize = computed(() => route.query.leftSize || "14px");
const rightSize = computed(() => route.query.rightSize || "14px");
const borderRadius = computed(() => route.query.borderRadius || "6px");
const logoWidth = computed(() => route.query.logoWidth || "20px");
const logoHeight = computed(() => route.query.logoHeight || "20px");
const link = computed(() => route.query.link || "");
const logo = computed(() => route.query.logo || "vuedotjs");
const leftText = computed(() => route.query.leftText || "creator");
const rightText = computed(() => route.query.rightText || "Jinx");
const leftColor = computed(() => route.query.leftColor || "#555");
const rightColor = computed(() => route.query.rightColor || "#4c1");
const logoColor = computed(() => route.query.logoColor || "#4c1");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WebComponent, {
    link: link.value,
    logo: logo.value,
    leftText: leftText.value,
    rightText: rightText.value,
    leftColor: leftColor.value,
    rightColor: rightColor.value,
    logoColor: logoColor.value,
    leftSize: leftSize.value,
    rightSize: rightSize.value,
    borderRadius: borderRadius.value,
    logoWidth: logoWidth.value,
    logoHeight: logoHeight.value
  }, null, 8, ["link", "logo", "leftText", "rightText", "leftColor", "rightColor", "logoColor", "leftSize", "rightSize", "borderRadius", "logoWidth", "logoHeight"]))
}
}

})